<template>
    <section>
        <div v-if="isLoading">
            <b-loading active></b-loading>
        </div>
        <div v-else>
            <div v-if="!isAuthenticated">
                <login></login>
            </div>
            <div v-else>
                <navbar></navbar>
                <div class="columns is-marginless">
                    <sidebar />
                    <div class="column">
                        <b-message v-for="(erro, index) in erros" v-bind:key="index" title="Erro" type="is-danger" aria-close-label="Fechar mensagem">
                            {{ erro }}
                        </b-message>
                        <router-view />
                    </div>
                </div>
                <div id="body">
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import login from '@/components/login.vue'
    import navbar from '@/components/navbar.vue'
    import sidebar from '@/components/sidebar.vue'
    import { mapState, mapActions, mapMutations } from 'vuex'

    export default {
        name: 'home',
        components: {
            login,
            navbar,
            sidebar
        },
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize()
            this.restoreContext()
        },
        computed: {
            menu() {
                return [
                    [
                        {
                            to: '/',
                            icon: 'desktop-mac',
                            label: 'Painel de controle'
                        }
                    ],
                    'Integradores',
                    [
                        {
                            to: '/notasfiscais',
                            label: 'Notas Fiscais',
                            icon: 'receipt'
                        }
                    ]
                ]
            },
            ...mapState([
                'erros',
                'isLoading',
                'isAuthenticated'
            ]),
        },
        methods: {
            ...mapActions([
                'logout',
                'restoreContext'
            ]),
            ...mapMutations('components', [
                'handleResize',
                'setSidebar',
            ])
        }
    }
</script>
